import { render, staticRenderFns } from "./ManageProductsPackage.vue?vue&type=template&id=3773236a&scoped=true"
import script from "./ManageProductsPackage.vue?vue&type=script&lang=js"
export * from "./ManageProductsPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773236a",
  null
  
)

export default component.exports